<template>
  <aside 
    class="h-screen flex flex-col transition-all duration-300 relative pt-2 select-none z-50 border-r"
    :class="[
      isCollapsed ? 'w-20' : 'w-64',
      isDark ? 'bg-zinc-950 border-zinc-900 text-zinc-400' : 'bg-white border-zinc-100 text-zinc-500'
    ]"
  >
    <button
      @click="isCollapsed = !isCollapsed"
      class="absolute -right-3 top-7 w-6 h-6 flex items-center justify-center rounded-full border transition-all duration-200 focus:outline-none"
      :class="isDark 
        ? 'bg-zinc-900 border-zinc-800 text-zinc-500 hover:text-white shadow-xl shadow-black/40' 
        : 'bg-white border-zinc-200 text-zinc-400 hover:text-zinc-800 shadow-sm'"
    >
      <svg class="w-3 h-3 transition-transform duration-200" :class="{'rotate-180': isCollapsed}" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    </button>

<div class="h-14 flex items-center px-5 border-b overflow-hidden shrink-0 transition-colors duration-200"
  :class="isDark ? 'border-zinc-900/60' : 'border-zinc-100/60'">
  <div class="flex items-center gap-2.5" :class="[isCollapsed ? 'mx-auto' : '']">
    
    <!-- Utilisation d'une condition ternaire pour le src du logo -->
    <img v-if="isDark" 
      src="../assets/Bookmysalon_White.svg" 
      class="h-10 w-auto rounded-md" 
      alt="Logo" 
    />

        <img v-else
       src="../assets/Bookmysalon_Black.svg"
      class="h-10 w-auto rounded-md" 
      alt="Logo" 
    />
    
    
    <span v-if="!isCollapsed" class="text-[9px] font-mono tracking-widest px-1.5 py-0.5 rounded transition-colors duration-200"
      :class="isDark ? 'bg-zinc-900 text-zinc-400' : 'bg-zinc-100 text-zinc-600'">PRO</span>
  </div>
</div>

    <nav class="flex-1 px-3 py-5 space-y-6 overflow-y-auto no-scrollbar">

      <div class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Pilotage
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => ['Dashboard'].includes(i.label))"
          :key="item.label"
          :to="item.to"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide transition-colors">{{ item.label }}</span>
        </RouterLink>
      </div>

      <div v-if="hasPermission('planning')" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Flux & Agendas
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => i.label === 'Rendez-vous')"
          :key="item.label"
          :to="item.to"
          @click="markAsChecked"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150 relative"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide flex-1">{{ item.label }}</span>

          <!-- Badge de notification avec animation de clignotement -->
          <span
            v-if="newAppointmentsCount > 0"
            class="notification-badge"
            :class="[
              isDark ? 'bg-red-600 text-white' : 'bg-red-500 text-white',
              isCollapsed ? 'absolute -top-1 -right-1' : ''
            ]"
          >
            {{ newAppointmentsCount }}
          </span>
        </RouterLink>

        <div v-if="!isCollapsed" class="pl-4 pr-1 pt-0.5 space-y-0.5 ml-5 border-l transition-colors duration-200"
          :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <RouterLink to="/appointments/list" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Liste des Rendez-Vous
          </RouterLink>
          <RouterLink to="/appointments/new" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Créer une réservation
          </RouterLink>
          <RouterLink to="/appointments/import" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Import & Sync
          </RouterLink>
        </div>
      </div>

      <div v-if="hasPermission('clients')" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Comptes Clients
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => i.label === 'Clients')"
          :key="item.label"
          :to="item.to"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">{{ item.label }}</span>
        </RouterLink>

        <div v-if="!isCollapsed" class="pl-4 pr-1 pt-0.5 space-y-0.5 ml-5 border-l transition-colors duration-200"
          :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <RouterLink to="/clients/new" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Crée un Client
          </RouterLink>
        </div>
      </div>

      <div v-if="hasAnyPermission(['prestations', 'services', 'categories'])" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Catalogue Métier
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => i.label === 'Services / Prestations')"
          :key="item.label"
          :to="item.to"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581a2.25 2.25 0 003.182 0l5.171-5.17a2.25 2.25 0 000-3.181L12.012 3.659A2.25 2.25 0 0010.415 3zM6.75 6.75h.008v.008H6.75V6.75z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">{{ item.label }}</span>
        </RouterLink>

        <div v-if="!isCollapsed" class="pl-4 pr-1 pt-0.5 space-y-0.5 ml-5 border-l transition-colors duration-200"
          :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <RouterLink v-if="hasAnyPermission(['services', 'prestations'])" to="/services/new" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Crée un Service
          </RouterLink>
          <RouterLink v-if="hasPermission('categories')" to="/services/categories" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
             Crée une Catégorie
          </RouterLink>
        </div>
      </div>

      <div v-if="accountType !== 'solo' && hasPermission('collaborateurs')" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Ressources & Staff
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => i.label === 'Staff / Employés')"
          :key="item.label"
          :to="item.to"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">{{ item.label }}</span>
        </RouterLink>

        <div v-if="!isCollapsed" class="pl-4 pr-1 pt-0.5 space-y-0.5 ml-5 border-l transition-colors duration-200"
          :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <RouterLink to="/staff/new" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Ajouter un Utilisateurs
          </RouterLink>
          <RouterLink to="/staff/schedules" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Horaires & Congés
          </RouterLink>
        </div>
      </div>

      <div v-if="hasPermission('caisse')" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Comptabilité
        </h3>
        <RouterLink
          v-for="item in generalMenu.filter(i => i.label === 'Finances')"
          :key="item.label"
          :to="item.to"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75m0 .75h-.75m.75 0v1.5m0 6.75v.75m0 .75h-.75m.75 0V13.5m0-2.25H4.5a.75.75 0 000-1.5h-.75m0-3h.75A.75.75 0 005.25 6h-.75m13.5 10.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM6.75 18h10.5a.75.75 0 00.75-.75V3.75a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">{{ item.label }}</span>
        </RouterLink>

        <div v-if="!isCollapsed" class="pl-4 pr-1 pt-0.5 space-y-0.5 ml-5 border-l transition-colors duration-200"
          :class="isDark ? 'border-zinc-900' : 'border-zinc-100'">
          <RouterLink to="/caisse" class="block text-[11px] px-3 py-1.5 rounded-lg transition-colors"
            :active-class="isDark ? 'text-[#D5CCBC] bg-zinc-900/40 font-medium' : 'text-zinc-900 bg-zinc-50 font-medium'"
            :class="isDark ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-400 hover:text-zinc-700'">
            Caisse
          </RouterLink>
        </div>
      </div>

      <div v-if="hasAnyPermission(['promotions', 'fidelite'])" class="space-y-1">
        <h3 v-if="!isCollapsed" class="text-[9px] font-medium uppercase tracking-widest px-3 mb-2 transition-colors duration-200"
          :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
          Marketing
        </h3>
        <RouterLink
          v-if="hasPermission('fidelite')"
          to="/promotions-fidelite"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 568l3-3m0 0l3-3m-3 3V7.5M12 15v-3m0 0l3-3m-3 3l-3-3m12 6.75a6 6 0 11-12 0 6 6 0 0112 0z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">Promotion & Fidélité</span>
        </RouterLink>
        <RouterLink
          v-if="hasPermission('promotions')"
          to="/promotions"
          class="group flex items-center gap-3 rounded-xl text-xs px-3 py-2 transition-all duration-150"
          :active-class="isDark ? 'bg-zinc-900 text-white font-medium' : 'bg-zinc-100 text-zinc-900 font-medium'"
          :class="isDark ? 'hover:bg-zinc-900/40 text-zinc-400' : 'hover:bg-zinc-50 text-zinc-600'"
        >
          <svg class="w-4 h-4 shrink-0 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581a2.25 2.25 0 003.182 0l5.171-5.17a2.25 2.25 0 000-3.181L12.012 3.659A2.25 2.25 0 0010.415 3zM6.75 6.75h.008v.008H6.75V6.75z" />
          </svg>
          <span v-if="!isCollapsed" class="tracking-wide">Happy Hours</span>
        </RouterLink>
      </div>

    </nav>

    <div class="border-t p-3 space-y-2.5 shrink-0 transition-colors duration-200"
      :class="isDark ? 'border-zinc-900/80 bg-zinc-950' : 'border-zinc-100 bg-white'">
      
      <div v-if="!isCollapsed && accountType" class="px-3 py-1.5 rounded-xl border transition-colors duration-200" 
        :class="[
          subscriptionType === 'lifetime'
            ? (isDark ? 'bg-purple-950/20 border-purple-900/30 text-purple-300' : 'bg-purple-50 border-purple-100 text-purple-800')
            : (isDark ? 'bg-zinc-900/40 border-zinc-900 text-zinc-400' : 'bg-zinc-50 border-zinc-200/60 text-zinc-700')
        ]">
        <div class="flex items-center gap-2">
          <span class="text-[9px] font-mono font-medium uppercase tracking-wider">
            <template v-if="subscriptionType === 'lifetime'">✦ Plan Lifetime</template>
            <template v-else>
              ● Plan {{ accountType === 'solo' ? 'Solo' : accountType === 'equipe' ? 'Équipe' : 'Salon' }}
            </template>
          </span>
        </div>
      </div>

      <RouterLink
        to="/settings"
        class="block p-1.5 rounded-xl transition-colors duration-150"
        :class="isDark ? 'hover:bg-zinc-900/60' : 'hover:bg-zinc-50'"
      >
        <div class="flex items-center justify-between gap-2" :class="[isCollapsed ? 'justify-center' : '']">
          <div class="flex items-center gap-2.5 min-w-0">
            <img
              :src="user.photo || 'https://ui-avatars.com/api/?background=f4f4f5&color=18181b&name=' + user.nom + '+' + user.prenom"
              :key="user.photo"
              @error="handleImageError"
              alt="Avatar"
              class="w-8 h-8 rounded-full object-cover border shrink-0 transition-colors duration-200"
              :class="isDark ? 'border-zinc-800' : 'border-zinc-200'"
            />
            <div v-if="!isCollapsed" class="min-w-0 text-left">
              <p class="text-xs font-medium truncate leading-tight transition-colors duration-200" :class="isDark ? 'text-white' : 'text-zinc-900'">
                {{ user.prenom }} {{ user.nom }}
              </p>
              <p class="text-[9px] truncate font-mono mt-0.5 transition-colors duration-200" :class="isDark ? 'text-zinc-600' : 'text-zinc-400'">
                {{ user.email }}
              </p>
            </div>
          </div>
          <svg v-if="!isCollapsed" class="w-3 h-3 text-zinc-400 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </RouterLink>

      <div :class="[isCollapsed ? 'flex justify-center' : 'px-1.5']">
        <ThemeToggle />
      </div>

      <button
        @click="logout"
        class="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-xl transition-all duration-150 font-normal text-[10px] uppercase tracking-wider border shadow-sm cursor-pointer"
        :class="isDark
          ? 'bg-zinc-900 border-zinc-800 text-zinc-400 hover:text-white hover:border-zinc-700 shadow-none'
          : 'bg-white border-zinc-200 text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900'"
      >
        <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
        </svg>
        <span v-if="!isCollapsed">Déconnexion</span>
      </button>
    </div>

  </aside>
</template>

<style scoped>
/* Clean system scrollbar hide for layout uniformity */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<script>
import { RouterLink } from "vue-router";
import api from '@/api';
import ThemeToggle from "./ThemeToggle.vue";

// Variable globale injectée ou reçue par props pour basculer de thème
import DashboardIcon from "./Icons/DashboardIcon.vue";
import UserIcon from "./Icons/UserIcon.vue";
import FileIcon from "./Icons/FileIcon.vue";
import GearIcon from "./Icons/GearIcon.vue";
import WalletIcon from "./Icons/WalletIcon.vue";
import ReportIcon from "./Icons/ReportIcon.vue";

import { useTheme } from '@/composables/useTheme';
import { usePermissions } from '@/composables/usePermissions';
import { useNotifications } from '@/composables/useNotifications';



export default {
  components: { RouterLink, ThemeToggle },
data() {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const role = storedUser.role || "agence";

  // Charger les vraies infos utilisateur depuis localStorage
  const userInfo = {
    prenom: storedUser.prenom || "Utilisateur",
    nom: storedUser.nom || "",
    email: storedUser.email || "",
    photo: storedUser.photo || null
  };

const baseMenu = [
  { 
    label: "Dashboard", to: "/", icon: DashboardIcon 
  },
  { 
    label: "Rendez-vous", to: "/appointments", icon: WalletIcon,
    children: [
      { label: "Calendrier", to: "/appointments/calendar" },
      { label: "Liste", to: "/appointments/list" },
      { label: "Créer un RDV", to: "/appointments/new" }
    ]
  },
  { 
    label: "Clients", to: "/clients", icon: UserIcon,
    children: [
      { label: "Liste clients", to: "/clients/list" },
      { label: "Ajouter client", to: "/clients/new" }
    ]
  },
  { 
    label: "Services / Prestations", to: "/services", icon: FileIcon,
    children: [
      { label: "Liste services", to: "/services/list" },
      { label: "Ajouter service", to: "/services/new" },
      { label: "Catégories", to: "/services/categories" }
    ]
  },
  { 
    label: "Staff / Employés", to: "/staff", icon: ReportIcon,
    children: [
      { label: "Liste employés", to: "/staff/list" },
      { label: "Ajouter employé", to: "/staff/new" },
      { label: "Horaires & Vacances", to: "/staff/schedules" }
    ]
  },
  { 
    label: "Finances", to: "/finance", icon: WalletIcon,
    children: [
      { label: "Paiements reçus", to: "/finance/received" },
      { label: "Rapports mensuels", to: "/finance/reports" }
    ]
  },
  { 
    label: "Paramètres", to: "/settings", icon: GearIcon,
    children: [
      { label: "Profil salon", to: "/settings/profile" },
      { label: "Notifications", to: "/settings/notifications" },
      { label: "Intégration Stripe", to: "/settings/payments" }
    ]
  }
];


  return {
    isCollapsed: false,
    notifCount: 5,
    accountType: localStorage.getItem('accountType') || 'solo', // Charger depuis localStorage d'abord, puis l'API
    subscriptionType: localStorage.getItem('subscriptionType') || 'flexible', // 'flexible' ou 'lifetime'

    user: userInfo,

    generalMenu: baseMenu.filter(
      item => !(role === "employe" && item.label === "Paiements & Finance")
    ),

    settingsMenu: [
      { label: "Paramètres", to: "/settings", icon: GearIcon }
    ],

    // 🔹 Partage logiciel
    shareLink: 'https://dimotec.datafuse.fr',
shareMessage: "Salut ! Découvre ce super logiciel pour gérer tes devis et suivre tes ordres de mission avec Diagnostics Immobilier. Ils s'occupent de tous les diagnostics immobiliers et optent pour la simplicité : https://dimotec.datafuse.fr"
  };
},


// 1. AJOUTE CE BLOC ICI
  setup() {
    const { isDark } = useTheme();
    const { hasPermission, hasAnyPermission, isAdmin, loadPermissions } = usePermissions();
    const { newAppointmentsCount, soundEnabled, toggleSound, markAsChecked } = useNotifications();

    // Recharger les permissions au montage
    loadPermissions();

    return {
      isDark,
      hasPermission,
      hasAnyPermission,
      isAdmin,
      newAppointmentsCount,
      soundEnabled,
      toggleSound,
      markAsChecked
    };
  },


  computed: {
    themeClasses() {
      
      return {
        
        text: "text-white",
        header: "border-gray-200",
        link: "hover:bg-[#D5CCBC] hover:text-black ",
        active: "bg-[#D5CCBC] text-black font-medium",
        logout: "bg-red-600 hover:bg-red-700 text-white",
        footer: "text-gray-400 hover:text-gray-200",
      };
    },
  },
  methods: {
     // 🔹 Partage logiciel
  shareByEmail() {
    const mailto = `mailto:?subject=Découvre ce logiciel&body=${encodeURIComponent(this.shareMessage)}`;
    window.location.href = mailto;
  },

  copyShareLink() {
    navigator.clipboard.writeText(this.shareLink)
      .then(() => alert('Lien copié dans le presse-papiers !'))
      .catch(() => alert('Impossible de copier le lien.'));
  },
    logout() {
      localStorage.removeItem("token");
      window.location.href = "/login";
    },

    handleImageError(event) {
      // Si l'image de profil échoue, utiliser le fallback
      console.warn('Erreur de chargement de la photo de profil, utilisation du fallback');
      event.target.src = `https://ui-avatars.com/api/?background=f4f4f5&color=18181b&name=${this.user.nom}+${this.user.prenom}`;
    },

    // Charger les informations de la firme pour adapter la navigation
    async loadFirmInfo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        // Charger les infos du profil utilisateur
        try {
          const profileResponse = await api.auth.getProfile();
          if (profileResponse.data && profileResponse.data.admin) {
            const profile = profileResponse.data.admin;

            // Mettre à jour les infos utilisateur depuis le profil (toujours prendre les valeurs du backend)
            this.user.prenom = profile.prenom || this.user.prenom;
            this.user.nom = profile.nom || this.user.nom;
            this.user.email = profile.email || this.user.email;
            this.user.telephone = profile.telephone || this.user.telephone;
            // Forcer la mise à jour de la photo depuis le backend (même si null/vide)
            if (profile.photo !== undefined) {
              this.user.photo = profile.photo;
            }

            // Mettre à jour localStorage avec les nouvelles données
            const updatedUser = {
              ...JSON.parse(localStorage.getItem('user') || '{}'),
              id: profile._id,
              prenom: profile.prenom,
              nom: profile.nom,
              email: profile.email,
              telephone: profile.telephone,
              photo: profile.photo || null  // Stocker null si pas de photo
            };
            localStorage.setItem('user', JSON.stringify(updatedUser));

            console.log('👤 Profil utilisateur chargé:', this.user.prenom, this.user.nom, 'Photo:', this.user.photo ? 'présente' : 'absente');
          }
        } catch (profileError) {
          console.error('Erreur lors du chargement du profil:', profileError);
        }

        // Charger les infos de la firme
        const response = await api.settings.getSalonInfo();

        if (response.data && response.data.firm) {
          // Récupérer le type_compte depuis la firme
          this.accountType = response.data.firm.type_compte || 'solo';
          this.subscriptionType = response.data.firm.type_tarification || 'flexible';

          console.log('📊 Type de compte:', this.accountType);
          console.log('💎 Type de tarification:', this.subscriptionType);

          // Sauvegarder dans localStorage pour la protection de routes
          localStorage.setItem('accountType', this.accountType);
          localStorage.setItem('subscriptionType', this.subscriptionType);
        }
      } catch (error) {
        console.error('Erreur lors du chargement des infos de la firme:', error);
        // En cas d'erreur, garder 'solo' par défaut pour des raisons de sécurité
        this.accountType = 'solo';
      }
    },

  },
  mounted() {
  console.log("Contenu de localStorage user :", localStorage.getItem("user"));
  this.loadFirmInfo();
},


};
</script>

<style>
/* Masquer la scrollbar tout en gardant le scroll fonctionnel */
.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE et Edge */
  scrollbar-width: none;     /* Firefox */
}

/* Badge de notification avec animation de clignotement */
.notification-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 9999px;
  animation: blink 1.5s ease-in-out infinite;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}
</style>